(function() {
    'use strict';

    angular
        .module('liverunApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
